import React from "react";
import Loadable from "ui-component/Loadable";

const MspDevicesTab = Loadable(() => import("../mspMenu/mspDevicesTab"));
const DeviceGroupLevelDevice = () => {
return( <MspDevicesTab callingFrom="deviceGroupLevel"/>);
}
export default DeviceGroupLevelDevice;